/**
 * The page someone was on before opening Help & support, so a new ticket can say
 * where they came from (ADR-0093). In memory only: a path, never its query
 * string, and gone when the tab closes.
 */

import { HELP_SUPPORT_PATH } from "./helpSupportPath";

let last: string | null = null;

export function rememberPage(pathname: string): void {
  if (!pathname.startsWith(HELP_SUPPORT_PATH)) last = pathname;
}

export function lastPage(): string | null {
  return last;
}
